import { render } from "./tools.vue?vue&type=template&id=66062dfb&scoped=true"
import script from "./tools.vue?vue&type=script&lang=js"
export * from "./tools.vue?vue&type=script&lang=js"

import "./tools.vue?vue&type=style&index=0&id=66062dfb&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66062dfb"]])

export default __exports__